import classNames from "classnames";
import * as React from "react";
import { ReservationFrameStateTypeEnum } from "@graphql/__generated__/types";
import styles from "./index.module.css";

type Props = {
  state: ReservationFrameStateTypeEnum | null;
};

const ReservationFrameStateLabel: React.FC<Props> = ({ state }) => {
  switch (state) {
    case ReservationFrameStateTypeEnum.Active:
      return (
        <div className={styles.planStatus}>
          予約状況
          <span>
            <img src="/img/icon_ok_circle.svg" />
          </span>
        </div>
      );
    case ReservationFrameStateTypeEnum.Restricted:
      return (
        <div className={styles.planStatus}>
          予約状況<span>TEL</span>
        </div>
      );
    case ReservationFrameStateTypeEnum.Full:
      return (
        <div className={classNames(styles.planStatus, styles.full)}>
          予約状況<span>満席</span>
        </div>
      );
    default:
      return (
        <div className={styles.planStatus}>
          予約状況<span>ー</span>
        </div>
      );
  }
};

export default ReservationFrameStateLabel;
